
const getters = {
  getCancelInsuranceForm: state => cancelInsurancesIndex => (
    state.cancelInsurances[cancelInsurancesIndex].form
  )
}

export default getters